<!-- eslint-disable max-lines -->
<template>
  <div v-if="commonData">
    <!-- Navbar STart -->
    <header
      id="topnav"
      :class="{ 'bg-white': isWhiteNavbar === true }"
      class="defaultscroll sticky"
    >
      <div class="container">
        <!-- Logo container-->
        <div class="logo-container">
          <router-link v-if="navLight !== true" class="logo" to="/">
            <img :src="logoDark" height="80" alt="" />
          </router-link>
          <router-link v-else class="logo" to="/">
            <img :src="logoDark" class="l-dark" height="80" alt="" />
            <img :src="logoLight" class="l-light" height="80" alt="" />
          </router-link>
        </div>
        <div class="buy-button">
          <a
            :class="{
              'btn-light': navLight === true,
              'btn-outline-primary': navLight !== true
            }"
            :href="socialNetworks.facebook"
            class="btn btn-icon btn-pills"
            target="_blank"
          >
            <facebook-icon class="fea icon-sm fea-social" />
          </a>
          <a
            :class="{
              'btn-light': navLight === true,
              'btn-outline-primary': navLight !== true
            }"
            :href="socialNetworks.instagram"
            class="btn btn-icon btn-pills ml-1"
            target="_blank"
          >
            <instagram-icon class="fea icon-sm fea-social" />
          </a>
        </div>
        <!--end login button-->
        <!-- End Logo container-->
        <div class="menu-extras">
          <div class="menu-item">
            <!-- Mobile menu toggle-->
            <a class="navbar-toggle" :class="{ open: isCondensed === true }" @click="toggleMenu()">
              <div class="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </a>
            <!-- End mobile menu toggle-->
          </div>
        </div>

        <div id="navigation">
          <!-- Navigation Menu-->
          <ul class="navigation-menu" :class="{ 'nav-light': navLight === true }">
            <li>
              <router-link to="/" class="side-nav-link-ref" exact>
                {{ $t('menu.home') }}
              </router-link>
            </li>

            <li class="has-submenu">
              <a href="javascript:void(0)" @click="onMenuClick">
                {{ $t('menu.about') }}
              </a>
              <span class="menu-arrow"></span>
              <ul class="submenu">
                <li>
                  <router-link to="/our-company" class="side-nav-link-ref">
                    {{ $t('menu.ourCompany') }}
                  </router-link>
                </li>
                <li>
                  <router-link to="/what-we-do" class="side-nav-link-ref">
                    {{ $t('menu.whatWeDo') }}
                  </router-link>
                </li>
              </ul>
            </li>

            <li>
              <router-link to="/projects" class="side-nav-link-ref">
                {{ $t('menu.projects') }}
              </router-link>
            </li>
            <li>
              <router-link to="/contact" class="side-nav-link-ref">
                {{ $t('menu.contact') }}
              </router-link>
            </li>

            <language-switcher v-if="enabledLanguage" />
          </ul>
          <!--end navigation menu-->
          <div class="buy-menu-btn d-none mb-3">
            <a
              :class="{
                'btn-light': navLight === true,
                'btn-outline-primary': navLight !== true
              }"
              :href="socialNetworks.facebook"
              class="btn btn-icon btn-pills"
              target="_blank"
            >
              <facebook-icon class="fea icon-sm fea-social" />
            </a>
            <a
              :class="{
                'btn-light': navLight === true,
                'btn-outline-primary': navLight !== true
              }"
              :href="socialNetworks.instagram"
              class="btn btn-icon btn-pills ml-1"
              target="_blank"
            >
              <instagram-icon class="fea icon-sm fea-social" />
            </a>
          </div>
        </div>
        <!--end navigation-->
      </div>
      <!--end container-->
    </header>
    <!--end header-->
    <!-- Navbar End -->
  </div>
</template>

<script>
import { FacebookIcon, InstagramIcon } from 'vue-feather-icons';
import MediaQueriesMixin from 'mixins/MediaQueriesMixin';
import LanguageSwitcher from './LanguageSwitcher';

export default {
  name: 'Header',

  components: {
    LanguageSwitcher,
    FacebookIcon,
    InstagramIcon
  },

  mixins: [MediaQueriesMixin],

  props: {
    isWhiteNavbar: {
      type: Boolean
    },
    navLight: {
      type: Boolean
    }
  },

  data: () => ({
    isCondensed: false
  }),

  computed: {
    commonData() {
      return this.$store.getters['website/dataWebsite']('commonApp');
    },

    logoDark() {
      return this.commonData.logoDark.url;
    },

    logoLight() {
      return this.commonData.logoLight.url;
    },

    socialNetworks() {
      return this.commonData.socialNetworks;
    },

    enabledLanguage() {
      return this.commonData.enabledLanguage;
    }
  },

  watch: {
    $route() {
      this.checkActiveMenuItem();
      if (this.isCondensed && !this.desktop) {
        this.toggleMenu();
      }
    }
  },

  mounted() {
    const onwindowScroll = () => {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        document.getElementById('topnav').classList.add('nav-sticky');
        document.getElementById('back-to-top').style.display = 'inline';
      } else {
        document.getElementById('topnav').classList.remove('nav-sticky');
        document.getElementById('back-to-top').style.display = 'none';
      }
    };

    window.onscroll = () => {
      onwindowScroll();
    };
  },

  methods: {
    /**
     * Added class active in li tag when clicked in router link menu
     */
    checkActiveMenuItem() {
      const links = document.getElementsByClassName('side-nav-link-ref');
      let matchingMenuItem = null;
      for (let i = 0; i < links.length; i += 1) {
        if (window.location.pathname === links[i].pathname) {
          matchingMenuItem = links[i];
        } else {
          this.actionInRouteLink(links[i], 'remove', 'active');
        }
      }

      if (matchingMenuItem) {
        // matchingMenuItem.classList.add('active');
        this.actionInRouteLink(matchingMenuItem, 'add', 'active');
      }
    },

    actionInRouteLink(element, action, className) {
      const parent = element.parentElement;
      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList[action](className);
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList[action](className);
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList[action](className);
            const parent4 = parent3.parentElement;
            if (parent4) {
              const parent5 = parent4.parentElement;
              parent5.classList[action](className);
            }
          }
        }
      }
    },

    /**
     * Toggle menu
     */
    toggleMenu() {
      this.isCondensed = !this.isCondensed;
      if (this.isCondensed) {
        document.getElementById('navigation').style.display = 'block';
      } else document.getElementById('navigation').style.display = 'none';
    },

    /**
     * Menu clicked show the submenu
     */
    onMenuClick(event) {
      event.preventDefault();
      const nextEl = event.target.nextElementSibling.nextElementSibling;

      if (nextEl && !nextEl.classList.contains('open')) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove('open');
        }
        nextEl.classList.add('open');
        nextEl.previousElementSibling.classList.add('open');
      } else if (nextEl) {
        nextEl.classList.remove('open');
        nextEl.previousElementSibling.classList.remove('open');
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.logo-container {
  a {
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
